import Vuex from "vuex";

// function getToken() {}
export default new Vuex.Store({
  state: {
    appName: "taksaz",
    baseUrl: "https://amlaktaksaz.com/api",
    //baseUrl: "http://192.168.1.3/amlak/taksaz/api",
    show: false,
    snackbar: {
      text: "",
      color: "",
      timeout: 5000,
    },
    auth: {
      loggedIn: false,
    },
  },
  getters: {
    baseUrl: function (state) {
      return state.baseUrl;
    },
    appToken: function (state) {
      return state.auth.token;
    },
    auth: function (state) {
      return state.auth;
    },
  },
  mutations: {
    setToken(state, payload) {
      state.appToken = payload.token;
      state.auth = payload;
      localStorage.setItem("auth", JSON.stringify(payload));
    },
    checkToken(state) {
      let $auth = localStorage.getItem("auth");
      if ($auth) {
        state.auth = JSON.parse($auth);
      }
    },
    logout(state) {
      let obj = { loggedIn: false };
      localStorage.setItem("auth", JSON.stringify(obj));
      state.auth = obj;
    },
  },
  actions: {
    toast: function (context, payload) {
      context.commit("toast", payload);
    },
    checkToken({ commit }) {
      commit("checkToken");
    },
  },
  modules: {},
});
